import * as PropTypes from 'prop-types';
import cx from 'classnames';
import Input from '../../atoms/Input';
import Button from '../../atoms/Button';

const FormFindOrderInvoice = ({
    className,
    isLoading,
    handleConsultOrder,
    orderResult,
    orderValues,
    setOrderValues,
    handleResetValues,
    children,
}) => {
    return (
        <form
            onSubmit={(e) => handleConsultOrder(e)}
            className={cx(className, 'grid w-full grid-cols-2 gap-4')}
        >
            {/* ORDER NUMBER */}
            <Input
                id='order-number'
                key='orderNumber'
                name='orderNumber'
                className='col-span-2 lg:col-span-1'
                label='# Pedido'
                type='number'
                placeholder='2222553501'
                value={orderValues.publicId}
                onChange={(e) => setOrderValues({ ...orderValues, publicId: e })}
                required
            />

            {/* TOTAL */}
            <Input
                id='totalAmount'
                key='total'
                name='total'
                className='col-span-2 lg:col-span-1'
                label='Total'
                type='number'
                placeholder='$000.00'
                value={orderValues.total}
                onChange={(e) => setOrderValues({ ...orderValues, total: e })}
                required
            />

            {children && <div className='col-span-2 lg:order-last'>{children}</div>}

            <div className='col-span-2 my-6 flex flex-col justify-center gap-y-4 lg:flex-row lg:gap-x-10'>
                <Button
                    type='button'
                    variants='secondary'
                    size='md'
                    disabled={isLoading}
                    onClick={() => handleResetValues('order')}
                >
                    Limpiar
                </Button>
                <Button
                    type='submit'
                    size='md'
                    loading={isLoading}
                    disabled={Object.values(orderValues).some((v) => v === '')}
                >
                    {orderResult && orderResult?.found && orderResult?.canRequest
                        ? 'Continuar'
                        : 'Consultar pedido'}
                </Button>
            </div>
        </form>
    );
};

FormFindOrderInvoice.propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    orderResult: PropTypes.object,
    orderValues: PropTypes.object,
    setOrderValues: PropTypes.func,
    handleConsultOrder: PropTypes.func,
    handleResetValues: PropTypes.func,
    children: PropTypes.node,
};

export default FormFindOrderInvoice;
